import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PageHeader as Header } from 'antd';
import { HomeOutlined } from '@ant-design/icons';

import { findRecursive } from '../../utils/common';
import { menuItems as pages } from '../../layouts/BaseLayout';

const PageHeader = ({ extra }) => {
    const location = useLocation();
    const key = location.pathname;
    const page = useMemo(() => findRecursive(pages, key), [key]);

    const routes = [
        {
            path: '/',
            breadcrumbName: 'Home',
            icon: <HomeOutlined />,
        },
        {
            path: page?.key,
            breadcrumbName: page?.label,
        },
    ];

    const itemRender = (route, params, _routes, paths) => {
        const last = _routes.indexOf(route) === _routes.length - 1;
        const title = (
            <>
                {route.icon} {route.breadcrumbName}
            </>
        );
        return last ? <span>{title}</span> : <Link to={paths.join('/')}>{title}</Link>;
    };

    return (
        <Header
            className="page-header"
            title={page?.label}
            breadcrumb={{ routes, itemRender }}
            // subTitle="This is a subtitle"
            // itemRender={itemRender}
            extra={extra}
        />
    );
};

export default PageHeader;
